<template>
  <div class="container" :style="{'background-color': appColor}">
    <WidgetMap
      v-if="currentJob && options.showMap"
      class="widget-map"
      :markers="markers"
      :options="true"/>
    <!-- Move this to another comp -->
    <div class="tile is-ancestor">
      <div class="tile is-parent" v-if="currentJob">
        <div class="tile is-child box eta-container" :style="{'background-color': appColor}">
          <section :class="{ margin: currentJob.status_id >= 7 || pickUpStop && pickUpStop.status_id <= 4 }">
            <!-- <div v-if="currentJob.driver && currentJob.status_id < 5">
              <h2 class="title"># Stops ahead</h2>
            </div> -->
            <ul class="eta" v-if="estimatedTime && currentJob.status_id !=7 && currentJob.status_id != 8">
              <li><h2 class="title">{{estimatedTime}}</h2></li>
              <li>Estimated Arrival</li>
            </ul>
            <ul class="eta" v-if="dropoffTime && currentJob.status_id == 7">
              <li><h2 class="title">{{dropoffTime}}</h2></li>
              <li>Arrived</li>
            </ul>
            <h2 class="title" v-if="currentJob.status_id == 7">Completed</h2>
            <h2 class="title" v-if="pickUpStop && pickUpStop.status_id <= 4">Pending</h2>
          </section>
          <section v-if="pickUpStop && pickUpStop.status_id  >= 5 && currentJob.status_id < 7">
            <b-steps
                class="tracking-stepper"
                :style="{
                        '--pendingColor': pendingColor,
                        '--pendingBorder': pendingBorder,
                        '--previousColor': previousColor,
                        '--previousBorder': previousBorder,
                        '--activeColor': activeColor,
                        '--activeBorder': activeBorder,
                        '--lineConnectColor': lineConnectColor,
                        '--checkColor': checkColor
                        }"
                :label-position="'bottom'"
                :size="'is-small'"
                icon-pack="'fas'"
                v-model="activeStep"
                :mobile-mode="null"
                :has-navigation="false">

                <b-step-item label="Collected" icon="user" :clickable="false">
                </b-step-item>

                <b-step-item label="Heading to you" icon="fas account-plus" :clickable="false">
                </b-step-item>

                <b-step-item label="Arriving" icon="fas account-plus" :clickable="false">
                </b-step-item>

                <!-- <b-step-item v-if="currentJob.status_id != 8" label="Completed" icon="account-plus" :clickable="false">
                </b-step-item>

                <b-step-item v-if="currentJob.status_id == 8" label="Canceled" icon="account-plus" :clickable="false">
                </b-step-item> -->
            </b-steps>
          </section>

          <div>
            <span v-if="currentJob.status_id !=7" class="heading">Delivering To:</span>
            <span v-if="currentJob.status_id ==7" class="heading">Delivered To:</span> {{dropOffStop.location.short_name}}
          </div>
        </div>
        <div class="tile is-child box d-flex" :style="{'background-color': appColor}" v-if="currentJob.driver && currentJob.status_id == 4">
          <div v-if="options.driverName || options.vehicleColor || options.vehicleYear || options.vehicleMake || options.vehicleModel || options.showCallDriver" class="driver-section">
            <b-icon
              pack="fas"
              icon="user-circle"
              size="is-large">
            </b-icon>
            <div>
              <h4><strong>Contact Driver</strong></h4>
              <h4 v-if="options.driverName">{{currentJob.driver.first_name}}</h4>
                <span v-if="options.vehicleColor">{{vehicle.color}}</span>
                   <span v-if="options.vehicleYear">{{vehicle.year}}</span>
                   &nbsp;<span v-if="options.vehicleMake"> {{vehicle.make}}</span>
                  <span v-if="options.vehicleModel">{{vehicle.model}}</span>
            </div>
          </div>

          <div v-if="options.showCallDriver && currentJob.status_id !== 7 && currentJob.status_id !== 8" class="align-end">
            <b-button size="is-medium" @click="getMaskerDriverNumber('tel')" class="mr-5">
              <b-icon
                pack="fas"
                icon="phone"
                size="is-medium">
              </b-icon>
            </b-button>
            <b-button size="is-medium" @click="getMaskerDriverNumber('sms')">
              <b-icon
                pack="fas"
                icon="sms"
                size="is-medium">
              </b-icon>
            </b-button>
          </div>
        </div>

        <div class="tile is-child box d-flex" :style="{'background-color': appColor}" v-if="currentJob.driver && options.showCallBase && currentJob.status_id !== 8">
          <div class="driver-section">
            <b-icon
              style="visibility:hidden"
              pack="fas"
              icon="user-circle"
              size="is-large">
            </b-icon>
            <div>
              <h4><strong>Contact Store</strong></h4>
              <h4>{{options.company.name}}</h4>
            </div>
          </div>

          <div class="align-end">
            <a :href="`tel:${options.company && options.company.phone}`" target="_top">
              <b-button size="is-medium">
                <b-icon
                  pack="fas"
                  icon="phone"
                  size="is-medium">
                </b-icon>
              </b-button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentJob && currentJob.status_id == 7 && options.showRating">
      <div class="tile-spacer"></div>
      <div style="text-align:center">
        <h3 class="heading" style="margin:1em; font-size:1em">{{currentJob.driver_rating ? 'You rated your driver ' + currentJob.driver_rating + ' stars' : 'Rate your driver'}}</h3>

        <star-rating v-model="driverRating"
                    :inactive-color="'white'"
                    :border-color="'#34495e'"
                    :border-width="1"
                    :show-rating="false"
                    :read-only="driverRated"></star-rating>

        <div v-if="options.showNotes">
          <h3 class="heading" style="margin:1em; font-size:1em" v-if="currentJob.driver_rating_notes || !currentJob.driver_rating">Notes:</h3>
          <b-input style="width:80%; margin:auto;"
                  size="is-big" :disabled="currentJob.driver_rating"
                  maxlength="120" type="textarea"
                  v-model="driverNotes"></b-input>
        </div>

        <b-button v-if="!currentJob.driver_rating"
                  type="is-dark" style="margin:1em"
                  @click="rateDriver()">Submit</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import WidgetMap from '@/components/tracking-widget/WidgetMap.vue';
import StarRating from 'vue-star-rating';

import JobService from '@/components/job/service';
import StatusService from '@/components/job/status_service';
import RateDriverService from './service';
import DriverService from '@/components/driver/service';

import moment from 'moment';
import _ from 'lodash';

import { POINT_MARKER_ICON_CONFIG } from "@/common/constants/mapSettings";
import { CAR_MARKER_ICON_CONFIG } from "@/common/constants/mapSettings";

export default {
  components: {
    WidgetMap,
    StarRating
  },

  data() {
    return {
      estimatedTime: null,
      dropoffTime: null,
      markers: null,
      currentJob: null,
      currentStop: null,
      activeStep: 0,
      eta: null,
      polling: null,
      options: {},
      pendingColor: null,
      pendingBorder: null,
      previousColor: null,
      previousBorder: null,
      activeColor: null,
      activeBorder: null,
      lineConnectColor: null,
      appColor: null,
      driverRating: 0,
      driverRated: false,
      driverNotes: '',
      vehcile: null,
    }
  },

  methods: {
    pollData (job_hash) {
      this.polling = setInterval(() => {
      this.getJobByHash(job_hash);
      }, 30000)
	  },

    getJobByHash(job_hash) {
      JobService.getJobByHash(job_hash, (err, job) => {

          if (err) return;

          this.currentJob = job;
          this.vehicle = job.vehicle || job.driver.assigend_to_vehicle;
          this.pickUpStop = this.currentJob.stops.find((stop) => stop.type === 'pickup')
          this.dropOffStop = this.currentJob.stops.find((stop) => stop.type === 'dropoff')

          if (this.currentJob.driver_rating) {
            this.driverRating = this.currentJob.driver_rating;
            this.driverNotes = this.currentJob.driver_rating_notes;
            this.driverRated = true;
          }

          if (this.currentJob.dropoff_date) {
            this.dropoffTime = moment.utc(this.currentJob.dropoff_date).local().format('h:mma');
          }

          // // TO DO check this
          // if (!job.driver_id) {
          //   this.activeStep = -1;
          // } else if (job.status_id === 4) {
          //   this.activeStep = 0
          // } else if (job.status_id === 5 ) {
          //   this.activeStep = 2;
          // } else if (job.driver_id && job.status_id > 1) {
          //   this.activeStep = 1;
          // }

          if (StatusService.isInProgressAndNotCompleted(this.currentJob) && !StatusService.isInProgressAndNotCompleted(this.dropOffStop)) {
            this.activeStep = 0;
          } else if (StatusService.isInProgressAndNotCompleted(this.dropOffStop) && !StatusService.isInFront(this.dropOffStop)) {
            this.activeStep = 1;
          } else if (StatusService.isInFront(this.dropOffStop)) {
            this.activeStep = 2;
          }

          if (this.markers.length === 0) {
            this.markers.push(
              {
                id: 0,
                position: { lat: this.dropOffStop.location.latitude, lng: this.dropOffStop.location.longitude },
                icon: POINT_MARKER_ICON_CONFIG
              }
            );
          }

          if (job.driver && this.options.showDriverVehicle) {
            this.drawDriver(job.driver);
          }

          JobService.getETA(job.job_id, (err, res) => {
            if (res && res.length) {
              const currentEta = res.find(eta => eta.job_stop_id === this.dropOffStop.job_stop_id);
              this.estimatedTime = moment.utc(currentEta.estimated_arrival_date).local().format('h:mma');
            }
          });
        })
    },

    drawDriver(driver) {
      if (_.isEmpty(this.driverMarkers)) this.driverMarkers = {};
      const { driver_number, location, position } = driver;
      if (_.isEmpty(location)) return;
      const thisMarker = this.markers.find(el => el.type === 'driver');
      // if the marker already exists on the map, update its position
      if (thisMarker) {
        if (_.isEqual(thisMarker.location, location)) return;
        //thisMarker.location = location;
        this.markers.find( p => p.id === driver_number && ( p.position.lat = location.latitude, true ) && ( p.position.lng = location.longitude, true ) );
        return;
      }

      const marker = {
        id: driver_number,
        type: 'driver',
        position: { lat: location.latitude, lng: location.longitude },
        icon: CAR_MARKER_ICON_CONFIG,
        //scaledSize: new this.$refs.gmap.google.maps.Size(35, 35),
      }

      this.markers.push(marker);
    },

    rateDriver() {
      RateDriverService.rateDriver({
        rating: this.driverRating,
        job_hash: this.$route.query.job_hash,
        notes: this.driverNotes
      }, (err, data) => {
        this.getJobByHash(this.$route.query.job_hash);
      })
    },

    getMaskerDriverNumber(target) {
      DriverService.getMaskedDriverNumber(this.$route.query.job_hash, (err, data) => {
        if (data && data.phone) {
          window.open(`${target}:${data.phone}`, '_top');
        }
      })
    }
  },

  created(){
    const job_hash = this.$route.query.job_hash || null;
    this.options.showMap = !_.isNil(this.$route.query.show_map) ? !!+this.$route.query.show_map : false;
    this.options.driverName = !_.isNil(this.$route.query.driver_name) ? !!+this.$route.query.driver_name : false;
    this.options.vehicleModel = !_.isNil(this.$route.query.vehicle_model) ? !!+this.$route.query.vehicle_model : false;
    this.options.vehicleMake = !_.isNil(this.$route.query.vehicle_make) ? !!+this.$route.query.vehicle_make : false;
    this.options.vehicleYear = !_.isNil(this.$route.query.vehicle_year) ? !!+this.$route.query.vehicle_year : false;
    this.options.vehicleColor = !_.isNil(this.$route.query.vehicle_color) ? !!+this.$route.query.vehicle_color : false;
    this.options.contactOptions = this.$route.query.contact_options;
    this.options.company = this.$route.query.company_details ? JSON.parse(this.$route.query.company_details) : null;
    this.options.showRating = !_.isNil(this.$route.query.show_rating) ? !!+this.$route.query.show_rating : false;
    this.options.showNotes = !_.isNil(this.$route.query.show_notes) ? !!+this.$route.query.show_notes : false;
    this.options.showCallDriver = !_.isNil(this.$route.query.show_call_driver) ? !!+this.$route.query.show_call_driver : false;
    this.options.showCallBase = !_.isNil(this.$route.query.show_call_base) ? !!+this.$route.query.show_call_base : false;
    this.pendingColor = this.$route.query.pending_color || 'rgb(236, 240, 241)';
    this.pendingBorder = this.$route.query.pending_border || '#dbdbdb';
    this.previousColor = this.$route.query.primary_background_color || 'blue';
    this.previousBorder = this.$route.query.primary_border_color ||'#7957d5';
    this.activeColor = this.$route.query.primary_background_color || 'white';
    this.activeBorder = this.$route.query.primary_border_color || 'blue';
    this.lineConnectColor = this.$route.query.primary_border_color || '#7957d5';
    this.checkColor = this.$route.query.check_color || 'white';
    this.appColor = this.$route.query.app_background_color || '#ecf0f1';
    this.markers = [];
    this.lines =  [];

    this.getJobByHash(job_hash);
    this.pollData(job_hash);
  },

  beforeDestroy () {
	  clearInterval(this.polling);
  }
};
</script>

<style>
  .widget-map {
    height: 300px;
  }

  .eta-container {
    display: block;
    text-align: center;
  }

  .eta-container .eta {
    margin-bottom: 1rem;
  }

  .d-flex {
    display: flex !important;
    justify-content: space-between;
  }

  .driver-section {
    display:flex !important;
    flex-wrap: wrap;
    align-items: end;
  }

  .stops-container {
    width: 100%;
  }

  .tracking-stepper {
    margin-top: 1em;
  }

  .tracking-stepper .steps .step-items .step-item.is-previous .step-marker {
    background: var(--previousColor) !important;
    border-color: var(--previousBorder) !important;
  }

  .tracking-stepper .steps .step-items .step-item.is-previous .step-title {
    font-weight: 200 !important;
  }

  .tracking-stepper .steps .step-items .step-item.is-active .step-title {
    font-weight: 900 !important;
  }

  .tracking-stepper .steps .step-items .step-item .step-title {
    font-weight: 200 !important;
  }

  .tracking-stepper .steps .step-items .step-item.is-previous .step-marker:before {
    content:'\2713';
    display:inline-block;
    color: var(--checkColor);;
    padding: 0 0 0px 2px;
    font-size: 1.5em;
  }

  .tracking-stepper .steps .step-items .step-item.is-active .step-marker {
    background: var(--activeColor) !important;
    border-color: var(--activeBorder) !important;
  }

  .tracking-stepper .steps .step-items .step-link .step-marker {
    background: var(--pendingColor) !important;
    border-color: var(--pendingBorder) !important;
  }

  .tracking-stepper .step-item.is-active::before {
    background: var(--lineConnectColor) !important;
  }

  .tracking-stepper .step-item.is-previous::before {
    background: var(--lineConnectColor) !important;
  }

  .tracking-stepper .step-details {
    margin-top: 1em;
  }

  .heading {
    font-weight: 900;
  }

  .margin {
    margin-bottom: 1em;
  }

  .box {
    border-radius: 0px !important;
  }

  .vue-star-rating {
    display: block !important;
    margin-top: 0.5em;
  }

  .tile-spacer {
    border-top: 2px solid;
    margin-bottom:0.5em;
    width:90%;
    margin:auto;
  }

  .tile.is-ancestor {
    margin-left: 0rem !important;
    margin-right: 0rem !important;
  }

  .align-end {
    align-items: end;
    display: flex
  }
</style>



// WEBPACK FOOTER //
// src/components/tracking-widget/TrackingWidget.vue